import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { CommonMojoPhoneNumberValidator } from 'mojo-phone-input';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { candidatesUpdate, getCandidateForm } from '@collections/candidates';
import { DangerAlert } from '@shared/alert';
import * as FormActions from '@shared/form/store/form.actions';
import { Candidate, CandidateFormAdapter } from '@shared/models';
import { AttachmentParams, AttachmentService } from '@shared/services';

import { getCandidateFormId } from '../store';

@Component({
  selector: 'mojo-candidate-form',
  templateUrl: './candidate-form.container.html',
  styleUrls: ['./candidate-form.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateFormComponent {
  candidate$: Observable<Partial<CandidateFormAdapter>> = this.store.pipe(
    select(getCandidateFormId),
    switchMap((id: number) => this.store.pipe(select(getCandidateForm, { id }))),
  );

  photo: any;

  socialInfo: UntypedFormArray = new UntypedFormArray([]);
  form = new UntypedFormGroup({
    locationInput: new UntypedFormControl(),
    firstName: new UntypedFormControl(null, Validators.required),
    currentJobTitle: new UntypedFormControl(null, Validators.required),
    lastName: new UntypedFormControl(null, Validators.required),
    mail: new UntypedFormControl(null, Validators.email),
    mobile: new UntypedFormControl('', CommonMojoPhoneNumberValidator()),
    streetAddress: new UntypedFormControl(),
    socialInfo: this.socialInfo,
  });

  constructor(private attachmentService: AttachmentService, private store: Store<{}>) {}

  submit(id: number) {
    if (!this.form.invalid) {
      const newCandidate = {
        ...CandidateFormAdapter.toCandidate(this.form.getRawValue()),
        id,
      };
      this.saveAttachment$(newCandidate).subscribe((savedAttachment) => {
        this.store.dispatch(
          candidatesUpdate({
            payload: {
              ...newCandidate,
              candidateImageId: savedAttachment.id,
            },
          }),
        );
        this.store.dispatch(FormActions.formSubmit({}));
      });
    } else {
      this.form.markAllAsTouched();
      this.store.dispatch(new DangerAlert('Correct the errors first.'));
    }
  }

  close() {
    this.store.dispatch(FormActions.formClose({}));
  }

  saveAttachment$(candidate: Partial<Candidate>): Observable<{ id: number }> {
    const attachment: AttachmentParams = {
      associateModuleId: candidate.id,
      associationModule: AttachmentService.AssociationModule.CANDIDATE,
      associationType: AttachmentService.AssociationType.IMAGE,
      name: 'profile.png',
    };
    if (!!this.photo) {
      return !!candidate.candidateImageId
        ? this.attachmentService.update(this.photo, candidate.candidateImageId)
        : this.attachmentService.save(this.photo, attachment);
    } else {
      return of({ id: candidate.candidateImageId });
    }
  }
}
